<template>
  <div class="index" :class="{ 'over-flow-hidden': showCityChoose }">
    <ucar-img-header v-if="!vuexCompanyId"></ucar-img-header>
    <ucar-img-header
      v-else
      type="company-index"
      :company-name="companyName"
    ></ucar-img-header>
    <div class="index-body">
      <div class="index-body-block">
        <div class="index-city" @click="chooseCity">
          <img src="../../assets/postion.png" />
          <h2>
            {{
              vuexCurrentCity && vuexCurrentCity.name
                ? vuexCurrentCity.name
                : '选择服务城市'
            }}
          </h2>
        </div>
        <h2 @click="teamRecruit">企业加盟</h2>
      </div>
      <ul class="index-entry-wrapper" v-if="!vuexCompanyId">
        <li
          class="nocar-entry"
          v-if="
            !vuexCurrentCity.id ||
            vuexCurrentCity.noCar ||
            vuexCurrentCity.rentCar ||
            vuexCurrentCity.buyCar ||
            vuexCurrentCity.selfOperated
          "
          @click="go('nocar')"
        >
          <h2 class="nocar-entry">无车加入</h2>
          <p>无车也能开专车，多种模式可选择</p>
        </li>
        <li
          class="hascar-entry"
          v-if="!vuexCurrentCity.id || `${vuexCurrentCity.hasCar}` === '1'"
          @click="go('hascar')"
        >
          <h2 class="hascar-entry">带车加入</h2>
          <p>品牌可信赖，收入有保障</p>
        </li>
      </ul>
      <ul class="index-entry-wrapper" v-else>
        <li
          class="nocar-entry"
          v-if="
            !vuexCurrentCity.id ||
            vuexCurrentCity.noCar ||
            vuexCurrentCity.rentCar ||
            vuexCurrentCity.buyCar
          "
          @click="go('companyNocar')"
        >
          <h2 class="nocar-entry">无车加入</h2>
          <p>可租/可买合规车辆，自由接单</p>
        </li>
        <li
          class="hascar-entry"
          v-if="!vuexCurrentCity.id || `${vuexCurrentCity.hasCar}` === '1'"
          @click="go('companyHascar')"
        >
          <h2 class="hascar-entry">带车加入</h2>
          <p>优质订单，自有订单，轻松赚钱</p>
        </li>
      </ul>
      <!-- <div class="index-entry-button" @click="go">
        立即报名
      </div> -->
      <ul class="index-link-wrapper">
        <li @click="showShareDialog" v-if="!vuexCompanyId">邀请司机加入</li>
        <li @click="reLogin" v-if="enableQureyProcess">完善资料，查报名进度</li>
      </ul>
    </div>
    <transition name="fade" mode="out-in">
      <city-choose
        v-if="showCityChoose"
        @change="selectCity"
        :list="cityOptions"
        :value="vuexCurrentCity"
      ></city-choose>
    </transition>
    <ucar-share
      :show-share="showShare"
      @cancelShare="showShare = false"
    ></ucar-share>
  </div>
</template>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.index {
  display: flex;
  flex-flow: column nowrap;

  .index-body {
    flex: 1 0 auto;
    display: flex;
    flex-flow: column nowrap;
    padding: 30px;

    .index-body-block {
      display: flex;
      justify-content: space-between;

      .index-city {
        display: flex;
        align-items: flex-start;
        margin-bottom: 30px;

        img {
          margin-right: 10px;
          width: auto;
          height: 32px;
          vertical-align: middle;
        }
      }

      h2 {
        color: $ucar_font_color;
        font-size: $ucar_font_h4;
        height: 40px;
        line-height: 40px;

        &::after {
          content: '>';
          display: inline-block;
          margin-left: 8px;
        }
      }
    }

    ul.index-entry-wrapper {
      flex: 1 0 auto;

      li {
        height: 340px;
        background-size: 100% 100%;
        padding: 105px 0 0 50px;
        box-sizing: border-box;

        &.nocar-entry {
          background-image: url('../../assets/nocar-entry.png');
        }

        &.hascar-entry {
          background-image: url('../../assets/hascar-entry.png');
        }

        &:first-child {
          margin-bottom: 30px;
        }

        h2 {
          font-size: 40px;
          line-height: 1;
          display: flex;
          align-items: center;
          margin-bottom: 30px;

          &::after {
            margin-left: 20px;
            content: '';
            box-sizing: border-box;
            height: 20px;
            width: 20px;
            color: $ucar_font_assist_color;
            border-right: 2px solid currentColor;
            border-bottom: 2px solid currentColor;
            transform: rotate(-45deg);
          }
        }

        p {
          color: $ucar_price_color;
          font-size: $ucar_font_normal;
          line-height: 1;
        }
      }
    }

    ul.index-link-wrapper {
      margin-top: 30px;
      padding-bottom: 30px;
      display: flex;
      align-items: center;

      li {
        flex: 1 1 50%;
        text-align: center;
        color: $ucar_font_color;
        font-size: $ucar_font_h6;

        &::after {
          content: '>';
          display: inline-block;
          margin-left: 6px;
        }

        &:nth-of-type(2) {
          border-left: 1px solid $ucar_light_border; /* no */
        }
      }
    }

    .index-entry-button {
      margin-top: 30px;
      height: 88px;
      line-height: 88px;
      font-size: $ucar_font_h4;
      color: #fff;
      text-align: center;
      background-color: $ucar_main_button;
      border-radius: 20px;
    }
  }
}
</style>

<script>
import cityChoose from '../../components/city-choose'
import { transformCities, decodeCompanyId } from '../../utils/transform'
import { loginStatus } from '../../utils/constants'
import { getCompanyName } from '../../api'
import ucarStorage from '../../utils/storage'

export default {
  components: {
    cityChoose,
  },
  data() {
    return {
      companyName: '',
      enterType: '',
      companyId: '',
      showCityChoose: false,
      showShare: false,
      enableQureyProcess: true,
      disableChooseCity: false,
    }
  },
  watch: {
    vuexCurrentCity(val) {
      if (val.noCar || val.rentCar || val.buyCar || val.selfOperated) {
        this.trackEvent('XQ_home_nocar_show', 'show')
      }
      if (`${val.hasCar}` === '1') {
        this.trackEvent('XQ_home_withcar_show', 'show')
      }
    },
  },
  computed: {
    cityOptions() {
      return transformCities(this.vuexServiceCities)
    },
  },
  methods: {
    showShareDialog() {
      this.trackEvent('XQ_home_share_click')
      this.showShare = true
    },
    go(target) {
      if (!this.vuexCurrentCity.id) {
        this.$alert('请选择服务城市')
        return
      }
      let url = ''
      switch (target) {
        case 'nocar':
          this.trackEvent('XQ_home_nocar_click')
          url = '/introduction/nocar'
          break
        case 'hascar':
          this.trackEvent('XQ_home_withcar_click')
          url = '/introduction/hascar'
          break
        case 'companyNocar':
          url = `/company-introduction/?type=nocar&companyId=${encodeURIComponent(this.vuexCompanyId)}`
          break
        case 'companyHascar':
          url = `/company-introduction/?type=hascar&companyId=${encodeURIComponent(this.vuexCompanyId)}`
          break
        default:
          url = `/login?joinMode=join`
          this.setVuexDriverType(this.vuexCompanyId ? '2' : '1')
          break
      }
      this.$router.push(url)
    },
    reLogin() {
      this.trackEvent('XQ_home_ckbmjd_click')
      this.$router.push('/login')
    },
    chooseCity() {
      if (this.disableChooseCity) return
      this.showCityChoose = true
    },
    selectCity(val) {
      this.showCityChoose = false
      if (val) this.setVuexCurrentCity(val)
    },
    async locationComplete(status, result) {
      console.log('[amap position info]: \n', result)
      let body = {}
      if (result && result.info === 'SUCCESS' && result.addressComponent) {
        const { addressComponent, formattedAddress } = result
        body = {
          cityName: addressComponent.city,
          districtName: addressComponent.district,
          formatted_address: formattedAddress,
          province: addressComponent.province,
          street: addressComponent.street,
          number: addressComponent.streetNumber,
          mapFlag: 1,
        }
      } else {
        // 当用户尚未未选择服务城市且尚未报名成功或尚未登录查看报名进度则显示定位失败提示
        if (!this.vuexCurrentCity.id && !this.vuexRecruitId)
          this.$alert('定位失败，请手动选择服务城市')
      }
      // 企业招募则需要加入companyId参数
      if (this.vuexCompanyId) body.companyId = this.vuexCompanyId || 27
      const res = await this.setVuexServiceCities(body)
      const cityId = this.vuexCurrentCity.id || res.localCityId
      const arr = res.serviceCityList
      this.disableChooseCity = arr.length === 1
      if (cityId) {
        const target = arr.find((item) => {
          // 定位城市需判断此城市是否支持不同方式的报名，如果每一种均不支持，则不选中当前城市
          return (
            item.cityId === cityId &&
            (item.selfOperated !== 0 ||
              item.hasCar !== 0 ||
              item.noCar !== 0 ||
              item.rentCar !== 0 ||
              item.buyCar !== 0) &&
            (this.vuexCompanyId
              ? item.recruitObject !== 2
              : item.recruitObject !== 1)
          )
        })
        if (target) {
          await this.setVuexCurrentCity({
            ...target,
            id: target.cityId,
            name: target.cityName,
          })
        } else {
          this.setVuexCurrentCity({})
        }
      }
      // 当可选城市只有一个时，默认选择此城市，并且不可在选择城市
      if (arr.length === 1) {
        const target = arr[0]
        if (
          target.selfOperated !== 1 &&
          target.hasCar !== 1 &&
          target.noCar !== 1 &&
          target.rentCar !== 1 &&
          target.buyCar !== 1 &&
          (this.vuexCompanyId
            ? target.recruitObject === 2
            : target.recruitObject === 1)
        )
          return
        await this.setVuexCurrentCity({
          ...target,
          id: target.cityId,
          name: target.cityName,
        })
      }
    },
    async location() {
      // 如果司机已经选择过服务城市那么当进入首页时不再使用高德重新定位
      if (this.vuexCurrentCity.id) {
        await this.locationComplete()
        return
      }
      try {
        this.$loading.show()
        const mapObj = new AMap.Map('amap-container')
        mapObj.plugin('AMap.Geolocation', () => {
          const geolocation = new AMap.Geolocation({
            timeout: 5000,
            enableHighAccuracy: false, // 是否使用高精度定位，默认:true
            maximumAge: 0, // 定位结果缓存0毫秒，默认：0
            convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: false, // 显示定位按钮，默认：true
            buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: false, // 定位成功后在定位到的位置显示点标记，默认：true
            showCircle: false, // 定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: false, // 定位成功后将定位到的位置作为地图中心点，默认：true
          })
          mapObj.addControl(geolocation)
          geolocation.getCurrentPosition(this.locationComplete)
        })
      } catch (e) {
        console.log('amap error: \n', e)
        await this.locationComplete()
      }
    },
    async init() {
      // 初始化时，企业id永远为空字符串
      this.setVuexCompanyId('')
      if (this.loginStatus === loginStatus.fillInfo) {
        this.enableQureyProcess = false
      }
      let {
        channelType,
        inviteCode,
        Open_ID: openId,
        Union_ID: unionId,
        User_ID_Company: userIdCompany,
        Timestamp: timestamp,
        Sign: sign,
        showCityChoose,
        a,
        ucarfrom,
      } = this.$route.query
      if (showCityChoose) this.showCityChoose = true
      if (openId && unionId && userIdCompany && timestamp && sign) {
        this.setVuexWxQuery({
          wx_Open_ID: openId,
          openId,
          userId: userIdCompany,
          wx_Union_ID: unionId,
          wx_User_ID_Company: userIdCompany,
          wx_Timestamp: timestamp,
          wx_Sign: sign,
        })
        channelType = '1'
      }
      if (channelType) this.setVuexChannelType(channelType)
      if (inviteCode) this.setVuexInviteCode(inviteCode)
      if (ucarfrom) this.setVuexFrom(ucarfrom)
      let indexUrl = '/'
      if (a) {
        indexUrl = `/?a=${encodeURIComponent(a)}`
        this.setVuexCompanyId(decodeCompanyId(a))
        const data = await getCompanyName(this.vuexCompanyId)
        this.companyName = data.companyName
        this.setVuexCompanyName(this.companyName)
        await this.location()
      } else {
        await this.location()
      }
      this.setVuexIndexUrl(indexUrl)
    },
    teamRecruit() {
      if (!this.vuexCurrentCity.id) {
        this.$alert('请选择服务城市')
        return
      }
      this.$router.push('/team-introduction')
    },
    changeMode() {
      location.assign('/')
    },
    reload(event) {
      if (document.referrer && !/10101111\.com/.test(document.referrer)) {
        this.setVuexFrom('search')
        ucarStorage.setSession('document-referrer', document.referrer)
      }
      location.reload()
    },
    watchQueryChange() {
      window.addEventListener('hashchange', this.reload)
    },
    stopWatchQuery() {
      window.removeEventListener('hashchange', this.reload)
    },
  },
  mounted() {
    const routeTo = ucarStorage.getStorage('routeTo')
    const mobile = ucarStorage.getStorage('mobile')
    const recruitId = ucarStorage.getStorage('recruitId')
    if (!mobile || !recruitId) {
      this.resetLoginStatus()
    }
    if (routeTo && mobile && recruitId) {
      console.log(routeTo, 'rrrrrrrrrrrrrrr')
      this.setVuexPersonMobile(mobile)
      this.setVuexRecruitId(recruitId)
      console.log(this.vuexRecruitId)
      this.changeStatusToFillInfo()
      this.$router.push(`/${routeTo}`)
    }
    this.init()
    this.watchQueryChange()
  },
  destroyed() {
    this.stopWatchQuery()
  },
}
</script>
